import counterPropTypes from 'core/utils/prop-types/counter';

export default function withCounter(WrappedComponent) {
  function Counter(props, context) {
    return (
      <WrappedComponent
        counter={context.counterIssuer}
        {...props}
      />
    );
  }

  Counter.contextTypes = {
    counterIssuer: counterPropTypes,
  };

  return Counter;
}
